import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Typography,
  Box,
} from "@mui/material";

import { fontSizes } from "../../theme/font-sizes";
import { darkColors } from "../../theme/colors";
import {
  StyledProfileTableRow,
  StyledTableContainer,
} from "./table-styling/table-styling";
import { CurrencyIcon } from "../../constants/assets";

const UserBetsTable = ({ userBets }) => {
  return (
    <StyledTableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ACTIVITY</TableCell>
            <TableCell>Total Bets</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {userBets.map((userBet) => (
            <StyledProfileTableRow key={userBet.id}>
              <TableCell sx={{ color: "white" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      border: `2px solid ${darkColors.buttonTop}`,
                    }}
                    src={userBet.avatar}
                  />
                  <Box>
                    <Typography
                      fontFamily={"MontserratBold"}
                      fontSize={fontSizes.heading3}
                    >
                      On {userBet.name}
                    </Typography>
                    <Typography fontSize={fontSizes.body}>
                      <Box
                        component="span"
                        sx={{
                          color:
                            userBet.status === "Won"
                              ? darkColors.tableGreen
                              : darkColors.red,
                        }}
                      >
                        {userBet.status}
                      </Box>{" "}
                      <Box
                        component="span"
                        sx={{ color: darkColors.lightGray }}
                      >
                        {userBet.type === "race"
                          ? "Race at"
                          : "For Placing Bet On"}{" "}
                      </Box>
                      <Box component="span" sx={{ color: "white" }}>
                        {userBet.location}
                      </Box>
                    </Typography>
                  </Box>
                </Box>
              </TableCell>

              <TableCell sx={{ color: "white", fontSize: fontSizes.heading3 }}>
                <Box sx={{ display: "flex", alignItems: "start" }}>
                  <Typography pt={0.2}>
                    <CurrencyIcon />
                  </Typography>
                  +{userBet.totalWinning}
                </Box>
              </TableCell>
            </StyledProfileTableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default UserBetsTable;
